// extracted by mini-css-extract-plugin
export var attachmentContainer = "_m2-0";
export var fileList = "_m2-2";
export var removeFileButton = "_m2-1";